import * as React from "react";
import { useUSStatesCovidCases } from "../../../../../hooks/static-queries/use-us-states-covid-cases";
import { COVID_SOURCES } from "../../../../../constants/sources";
import FirePlot, { FirePlotData } from "./fireplots";

const USFirePlot: React.FC = () => {
  const USCases = useUSStatesCovidCases();

  if (!USCases) {
    return null;
  }

  return (
    <FirePlot
      countryName="United States"
      data={USCases as FirePlotData[]}
      sources={[COVID_SOURCES.NYT]}
    />
  );
};

export default USFirePlot;
